import { GoabText } from "@abgov/react-components";
import { ErrorPage } from "../../MPP-Common-SPA/components/ErrorPage/ErrorPage";
import { useSessionManagement } from "../../ServiceUtils/useSessionManagement";

export const NotFound = () => {
  const { getResourceValue } = useSessionManagement();
  const albertaSupportsCentreUrl = getResourceValue({
    key: "RESOURCES@url.alberta_supports",
  });

  return (
    <ErrorPage
      errorCode="Error 404"
      heading="The page you are looking for does not exist"
    >
      <GoabText maxWidth="none" mb="0">
        Please check the URL and try again. We apologize for the inconvenience.
      </GoabText>
      <GoabText maxWidth="none" mb="0">
        If you need assistance, visit an{" "}
        <a href={albertaSupportsCentreUrl}>Alberta Supports Centre</a>
      </GoabText>
      <GoabText maxWidth="none" mb="0">
        Or call the Alberta Supports Contact Centre at{" "}
        <a href="tel:1-877-644-9992">1-877-644-9992</a>.
      </GoabText>
    </ErrorPage>
  );
};

export default NotFound;
